<script setup>
import SectionHeading from './SectionHeading.vue'
import ToggleBox from './ToggleBox.vue'
import SmallPrint from './SmallPrint.vue'
import Alerts from './Alerts.vue'
import NoOfferBox from './NoOfferBox.vue'
import DevTools from './DevTools.vue'
import { config } from '@finn-no/huck-config'
import { noOffer, offerIsNull, messages } from './store.js'
</script>

<template>
  <div>
    <dev-tools v-if="config.isLocal" />
    <div v-if="!noOffer">
      <section-heading />
      <alerts />
      <no-offer-box v-if="offerIsNull && !messages.info.length" />
      <toggle-box v-else-if="!offerIsNull" />
      <small-print />
    </div>
  </div>
</template>
